import * as types from './types'

export const getFacilityReverses = (payload: any) => ({
  type: types.GET_FACILITY_REVERSES,
  payload,
})

export const addFacilityReverse = (payload: any) => ({
  type: types.ADD_FACILITY_REVERSE,
  payload,
})

export const editFacilityReverse = (payload: any) => ({
  type: types.EDIT_FACILITY_REVERSE,
  payload,
})

export const submitFacilityReverse = (payload: any) => ({
  type: types.SUBMIT_FACILITY_REVERSE,
  payload,
})

export const approveFacilityReverse = (payload: any) => ({
  type: types.APPROVE_FACILITY_REVERSE,
  payload,
})

export const rejectFacilityReverse = (payload: any) => ({
  type: types.REJECT_FACILITY_REVERSE,
  payload,
})

export const deleteFacilityReverse = (payload: any) => ({
  type: types.DELETE_FACILITY_REVERSE,
  payload,
})

export const startLoadingFacilityReverse = () => ({
  type: types.START_LOADING_FACILITY_REVERSE,
  payload: null,
})

export const stopLoadingFacilityReverse = () => ({
  type: types.STOP_LOADING_FACILITY_REVERSE,
  payload: null,
})
